import { render } from "./SetPartner.vue?vue&type=template&id=43fa6271"
import script from "./SetPartner.vue?vue&type=script&lang=js"
export * from "./SetPartner.vue?vue&type=script&lang=js"

import "./SetPartner.vue?vue&type=style&index=0&id=43fa6271&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__